import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { catchError, Observable, throwError } from 'rxjs';
import { WarehouseError } from '@app/store/shared/models';
import { CartonContents, ProductScan } from '../models';
import { CartonContentsDto } from '../models/carton-contents.dto';
import { ProductScanDto } from '../models/product-scan.dto';
import { mapDto } from '@shared/operators';
import { ApiResponse } from '@shared/models/api-response';

@Service()
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    scanProduct(ean: string): Observable<ProductScan> {
        return this.httpClient.post<ApiResponse<ProductScanDto>>('products/scan', { ean }).pipe(mapDto((response) => new ProductScan(response.data)));
    }

    addItem(cartonCode: string, ean: string): Observable<CartonContents> {
        return this.httpClient.post<ApiResponse<CartonContentsDto>>(`cartons/${cartonCode}/items`, { ean }).pipe(
            mapDto((response) => new CartonContents(response.data)),
            catchError((response: HttpErrorResponse) => throwError(() => new WarehouseError(response, marker('sorting.add.error.generic')))),
        );
    }
}
